import React from 'react';

export const Footer = () => {
  return (
    <footer className="footer">
      <p>© Copyright 2021 - Kiril Novytskyi</p>
    </footer>
  );
};
